import { FlowNodeBase, FlowNodePills } from './FlowNodeBase';
import { FlowNodeResourceChips } from './FlowNodeResourceChips';

interface FlowRouterNodeData {
  label: string;
  status: string;
  config: { labels: string[]; strategy: string; model?: string; providerSecretId?: string };
}

export function FlowRouterNode({
  data,
  selected,
}: {
  data: FlowRouterNodeData;
  selected?: boolean;
}) {
  return (
    <FlowNodeBase
      nodeType="router"
      label={data.label}
      selected={selected}
      isActive={data.status === 'running'}
      status={data.status}
    >
      <FlowNodePills labels={data.config.labels} />
      {data.config.strategy === 'llm' && (
        <FlowNodeResourceChips
          model={data.config.model}
          providerSecretId={data.config.providerSecretId}
          slots={{ model: true, providerKey: true }}
        />
      )}
    </FlowNodeBase>
  );
}
